<template>
    <div class="WarehouseOutbound">
      <!--  出仓单 -->
      <div
        style="justify-content: space-between; align-items: center"
        v-if="type === 'true'"
      >
        <!-- <van-button
          type="info"
          size="small"
          style="display: flex"
          :text="ray"
          @click="holdRay()"
        ></van-button> -->
        <div style="margin-top: 10%;display: flex; align-items: center; flex-wrap: nowrap; justify-content: space-evenly;">
          <input
            v-if="switch_in == 0"
            id="scanQRCode"
            ref="getIDInpot"
            @keyup.enter="add_gck_number()"
            v-model="add_data"
            readonly
            style="height: 28px; width: 180px ;"
            autocomplete="off"
            placeholder="扫描订单明细码（手输）"
          />
          <input
            v-if="switch_in == 1"
            id="scanQRCode"
            ref="getIDInpot2"
            @keyup.enter="add_number()"
            v-model="add_data"
            readonly
            style="height: 28px; width: 180px ;"
            autocomplete="off"
            placeholder="扫描货号条码（手输）"
          />
          <van-button type="info"  class="bottom-button-switch" @click="go_switch()">切换</van-button>
        </div>
      </div>
  
      <div :style="style" v-if="flag_x">
            <div class="data-top">
              <div class="right-twenty">货号</div>
              <div class="right-twenty">现存量</div>
              <div class="right-twenty">卷号</div>
              <div class="right-twenty">货位</div>
              <div class="right-twenty">仓库</div>
              <div style="width: 20px;">    </div>
            </div>
            <div class="data-top" v-for="(i, index) in w_data" :key="index" >
              <div class="data-order">{{ i.number }}</div>
              <div class="data-order">{{ i.store}}</div>
              <div class="data-order">{{ i.reel }}</div>
              <div class="data-order">{{ i.goods }}</div>
              <!--<div class="data-order" :style="{ color: i.mark !== '' ? 'black' : 'red' }">  
                <template v-if="i.mark !== ''">仓内</template><template v-else>仓外</template>
              </div>-->
              <div class="data-order">{{ i.warehouse }}</div>
              <van-radio :name="index" shape="square"  v-model="radio" @click="radio_sw(index)"></van-radio>
            </div>
            <div class="data-top">
              <van-button type="info" round class="bottom-button-x" @click="go_out()">出仓</van-button>
            </div>
      </div>
  
      <div class="filling-goods-bottom">
        <van-button type="warning" class="bottom-button" @click="go_index()">
          回首页
        </van-button>
        <!-- <van-button
          type="info"
          v-if="type === 'true'"
          @click="warehous"
          class="bottom-button"
        >
          确认入库
        </van-button>
        <van-button type="warning" @click="reload()">新建</van-button>
        <van-button type="info" class="bottom-button" @click="toInboundScanning()">入箱扫码</van-button> -->
      </div>
    </div>
  </template>
  
  <script>
  import { Dialog } from "vant";
  import { Toast } from "vant";
  import { get, post } from "@/utils/request";
  import { config } from "process";
  export default {
    name: "WarehouseOutbound",
    data() {
      return {
        ray: "已暂停，点击我继续扫码",
        add_data: "",
        all_data: [],
        w_data:"",
        mxm: "",
        style: "",
        type: "true",
        ware_type: 0,
        belong: "",
        flag_x:false,
        switch_in:0,
        radio:'',
        getnumber: (i) => {
          if (i.indexOf("-") === -1) {
            return i;
          } else {
            return i.substr(0, i.indexOf("-"));
          }
        },
      };
    },
    mounted() {
      var h = document.documentElement.clientHeight || document.body.clientHeight;
      this.style =
        "text-align: left;width: 100%;height: " + h * 0.78 + "px;overflow:scroll";
      this.holdRay();
    },
    methods: {
      // toInboundScanning() {
      //   this.$router.push({
      //     path: "/inboundScanning",
      //   });
      // },
      go_index() {
        //回到首页
        Dialog.confirm({
          message: "确定要回首页吗？",
        })
          .then(() => {
            this.$router.push("/home");
          })
          .catch(() => {
            // on cancel
          });
      },
      reload() {
        window.location.reload();
      },
      go_switch(){
        if(this.switch_in==0){
            this.switch_in=1
        }else{
            this.switch_in=0
        }
      },
      holdRay() {
        this.ray = "扫描中";
        if (this.add_data) {
          // 如果箱号的框有值
          this.$refs.getIDInpot2.focus();
          this.$refs.getIDInpot.setAttribute("readonly", "readonly");
          this.$refs.getIDInpot2.removeAttribute("readonly");
        } else {
          this.focus();
        }
      },
      focus() {
        this.$refs.getIDInpot.focus();
        this.$refs.getIDInpot.setAttribute("readonly", "readonly");
        setTimeout(() => {
          this.$refs.getIDInpot.removeAttribute("readonly");
        }, 200);
      },
      // hideMessage() {
      //   this.ray = "已暂停，点击我继续扫码";
      // },
      async add_gck_number() {
        let flag = true;
        if (!navigator.onLine) {
          Toast("当前网络故障");
          this.add_data = "";
          return;
        }
        if (this.add_data.indexOf("-") !== -1) {
            var add_data_head = this.add_data.substr(0, this.add_data.indexOf("-"));
          }
        else{
            var add_data_head = this.add_data;
          }
        await get(this.APIOBJ.WarehouseOutQuery,{
          gck_number: add_data_head,
        }).then((res) => {
          if (res.data.status == "1") {
            // 如果是1  就说明成功
            this.w_data = res.data.data.rools; // 获取货位
            Toast("扫描明细码成功");
            this.flag_x=true;
          } else {
            flag = false;
            Toast("明细码不存在，请重新扫描");
          }
        });
        // if (flag) {
        //   this.$refs.getIDInpot2.focus();
        //   this.$refs.getIDInpot.setAttribute("readonly", "readonly");
        //   this.$refs.getIDInpot2.removeAttribute("readonly");
        // }
      },
      async add_number() {
        let flag = true;
        if (!navigator.onLine) {
          Toast("当前网络故障");
          this.add_data = "";
          return;
        }
        await get(this.APIOBJ.WarehouseOutQuery,{
          number: this.add_data,
        }).then((res) => {
          if (res.data.status == "1") {
            // 如果是1  就说明成功
            this.w_data = res.data.data.rools; // 获取货位
            Toast("扫描货号成功");
            this.flag_x=true;
          } else {
            flag = false;
            Toast("订单不存在或者已删除");
          }
        });
        // if (flag) {
        //   this.$refs.getIDInpot2.focus();
        //   this.$refs.getIDInpot.setAttribute("readonly", "readonly");
        //   this.$refs.getIDInpot2.removeAttribute("readonly");
        // }
      },
      radio_sw(index){

          this.radio=index;
         
      },
      go_out(){
        if(this.radio !== ''){
          if (!navigator.onLine) {
            Toast("当前网络故障");
            this.add_data = "";
            return;
          }
          this.get(this.APIOBJ.WarehouseOutbound,{
            timeout: 10000,
            reel: this.w_data[this.radio].reel,
          }).then((res) => {
            if (res.data.status == "1") {
              Toast(res.data.msg);
              this.flag_x=false;
            } else {
              Toast(res.data.msg);
            }
          });
           console.log(this.w_data[this.radio]);
           //this.reload();
        }else{
            Toast("请选择要出仓的货号");
        }
      }
    },
  };
  </script>
  
  <style>
  .filling-goods-bottom {
    display: flex;
    position: absolute;
    bottom: 0;
    width: 100%;
    margin-left: -10px;
  }
  .goods-info-two {
    margin-top: 10px;
    background-color: #f2f2f2;
    padding-bottom: 10px;
  }
  .info-order-h {
    width: 100%;
    display: flex;
    padding-top: 5px;
  }
  .order-info-input {
    border-radius: 5px;
    border: 1px solid #444444;
    text-align: center;
    width: 4.5rem;
  }
  .info-order-data {
    width: 65%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .info-order-title {
    width: 35%;
  }
  .data-top{
    width: 100%; 
    display: flex; 
    align-items: center;
    flex-wrap: nowrap;
    justify-content: space-evenly;
    margin-top: 5%;
  }
  .right-twenty{
    /*padding-left: 5%;*/
    width: 18%;
    text-align: center;
  }
  .data-order{
    width: 18%;
    text-align: center;
    word-wrap: break-word;
  }
  .bottom-button-x{
    border-radius: 0.5em;
    width: 25%;
  }
  .bottom-button-switch{
    border-radius: 0.2em;
    width: 20%;
    height: 30px;
    text-align: center;
    line-height:normal;
  }
  </style>